import type AttendeeType from 'owa-service/lib/contract/AttendeeType';
import type WorkingHoursType from 'owa-service/lib/contract/WorkingHoursType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getAttendeeData } from '../selectors/attendeeSelectors';
import { getSessionMailboxInfo } from '../selectors/sessionSelectors';
import { getAttendeeKey } from './getAttendeeKey';

/**
 * Gets the WorkingHours for an attendee
 * @param sessionId The free busy cache session
 * @param attendee The attendee for which working hours are requested
 */
export function getAttendeeWorkingHours(
    sessionId: string,
    attendee: AttendeeType
): WorkingHoursType | undefined {
    const address = attendee.Mailbox?.EmailAddress;

    const defaultWorkingHours = getUserConfiguration()?.UserOptions?.WorkingHours;

    const mailboxInfo = getSessionMailboxInfo(sessionId);

    if (!address || !mailboxInfo) {
        return defaultWorkingHours;
    }

    const key = getAttendeeKey(address, mailboxInfo);

    const attendeeData = getAttendeeData(key);

    if (!attendeeData || !attendeeData.workingHours) {
        return defaultWorkingHours;
    }

    return attendeeData.workingHours;
}
